import { staticPath } from  '@/utils/baseUrl.js'
// import Home from './pages/ks/home/home.vue'
import Home from './pages/home/commonHome.vue'
// import SingClass from './pages/ks/courseContent/singleClass/index.vue'
// import CreateClass from './pages/ks/courseContent/singleClass/cearteClass.vue'
// import SpecialColumn from './pages/ks/courseContent/specialColumn/index.vue'
// import CreateColumn from './pages/ks/courseContent/specialColumn/createColumn.vue'
// import Chapter from './pages/ks/courseContent/specialColumn/chapter/index.vue'
// import CreateChapter from './pages/ks/courseContent/specialColumn/chapter/createChapter.vue'
import BasicInfo from './pages/ks/shopManagement/basicInfo.vue'
import Order from './pages/ks/profit/order.vue'
import Marketing from './pages/ks/marketing/marketing.vue'
import CreateMarket from './pages/ks/marketing/createMarket.vue'
// import CreateDynamic from './pages/ks/createDynamic/index'
// import CreateDynamicList from './pages/ks/createDynamic/list'
// import RelationShop from './pages/ks/relation/relation.vue'
// import CreateRelation from './pages/ks/relation/createRelation.vue'
import GettingUserInformation from './pages/gettingUserInformation/gettingUserInformation.vue'
export const ksList =  {
        path: staticPath + 'home',
        component:Home,
        children:[
        {
            path: staticPath + 'basicInfo', // 基本信息
            component: BasicInfo,
            meta: {
                id: 3,
                title: '基本信息',
                pathName: staticPath + 'basicInfo'
            }
        },
        // {
        //     path: staticPath + 'singClass',
        //     component:SingClass,
        //     meta: {
        //         id: 5,
        //         title: '单课',
        //         pathName: staticPath + 'singClass'
        //     }
        // },
        // {
        //     path: staticPath + 'createClass/:id?', // 新建单课
        //     component:CreateClass,
        //     name: 'CreateClass',
        //     meta: {
        //         title: '新建单课',
        //         saveBtnFlag: true,
        //         pathName: staticPath + 'singClass'
        //         // id: 211
        //     }
        // },
        // {
        //     path: staticPath + 'editClass/:id', // 编辑单课
        //     component:CreateClass,
        //     name: 'EditClass',
        //     meta: {
        //         // id: 212，
        //         title: '编辑单课',
        //         pathName: staticPath + 'singClass'
        //     }
        // },
        // {
        //     path: staticPath + 'preivewClass/:id', // 查看单课
        //     component:CreateClass,
        //     name: 'PreivewClass',
        //     meta: {
        //         // id: 212，
        //         title: '查看单课',
        //         pathName: staticPath + 'singClass'
        //     }
        // },
        // {
        //     path: staticPath + 'specialColumn',
        //     component:SpecialColumn,
        //     meta: {
        //         id: 6,
        //         title: '课程',
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'chapter/:id/:type?',
        //     component: Chapter,
        //     meta: {
        //         title: '章节',
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'createColumn/:id?', // 新建课程
        //     component:CreateColumn,
        //     name: 'CreateColumn',
        //     meta: {
        //         // id: 222
        //         title: '新建课程',
        //         saveBtnFlag: true,
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'editColumn/:id', // 修改课程
        //     component:CreateColumn,
        //     name: 'EditColumn',
        //     meta: {
        //         // id: 223,
        //         title: '编辑课程',
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'preivewColumn/:id', // 查看课程
        //     component:CreateColumn,
        //     name: 'PreivewColumn',
        //     meta: {
        //         // id: 223,
        //         title: '查看课程',
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'createChapter/:product_id/:type?', // 新建章节
        //     component:CreateChapter,
        //     name: 'CreateChapter',
        //     meta: {
        //         // id: 2244,
        //         title: '新建章节',
        //         saveBtnFlag: true,
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'editChapter/:product_id/:id/:type?', // 修改章节
        //     component:CreateChapter,
        //     name: 'EditChapter',
        //     meta: {
        //         // id: 2245,
        //         title: '编辑章节',
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'preivewChapter/:product_id/:id/:type?', // 修改章节
        //     component:CreateChapter,
        //     name: 'PreivewChapter',
        //     meta: {
        //         // id: 2245,
        //         title: '查看章节',
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        {
            path: staticPath + 'order', //  订单统计
            component:Order,
            meta: {
                id: 9,
                title: '订单统计',
                pathName: staticPath + 'order'
            }
        },
        {
            path: staticPath + 'marketing',
            component: Marketing,
            meta: {
                id: 15,
                title: '抢购活动',
                pathName: staticPath + 'marketing'
            }
        },
        {
            path: staticPath + 'createMarket',
            component: CreateMarket,
            meta: {
                title: '添加活动',
                pathName: staticPath + 'marketing'
            }
        },
        {
            path: staticPath + 'gettingUserInformation',
            name: 'GettingUserInformation',
            component: GettingUserInformation,
            meta: {
                title: '用户信息获取',
                id: 22,
                pathName: staticPath + 'gettingUserInformation'
            }
        },
    ]
}
